<template>
    <div class="input-container">
        <label>
            <input v-model="value"
                   :name="name"
                   :type="dataType"
                   autocomplete="off"
                   @focus="customFocus"
                   @blur="isEdited = true"
                   @input="$emit('input', $event.target.value)"
            />
            <span :class="{incorrect: validate && isEdited, beforeVisit : !isVisited}"
                  class="custom_placeholder"
                  v-html="placeholder">
            </span>
        </label>
        <transition name="fade">
             <span class="error-display"
                   v-if="validate && isEdited"
                   v-html="errorMsg">
        </span>
        </transition>

    </div>
</template>

<script>
    export default {
        name: "inputCustomRegister",
        props: ['placeholder', 'dataType', 'regex', 'require', 'name', 'errorMsg', 'isGloballyCorrectPass'],
        data() {
            return {
                value: '',
                isVisited: false,
                isIncorrect: false,
                isEdited: false,
                type: ''
            }
        },
        methods: {
            customFocus() {
                this.isVisited = true;
            },

            emitValidateData() {

                this.customFocus();
                this.isEdited = true;

                this.$parent.$emit('validateData', {
                    inputName: this.name,
                    isIncorrect: this.validate,
                    value: this.validate ? false : this.value,
                });
            },
        },

        computed: {
            validate() {
                if (this.require) {
                    let state = false;

                    if (this.regex) {
                        state = !this.regex.test(this.value);
                    } else {
                        state = this.value === '';
                    }

                    if (this.isGloballyCorrectPass !== undefined) {
                        state = !this.isGloballyCorrectPass;
                    }

                    return state;
                } else {
                    return false;
                }
            },
        },

        mounted() {
            this.$parent.$on('getValidateData', () => {
                this.emitValidateData();
            });
        }
    }
</script>

<style scoped lang="scss">

    .fade-enter-active, .fade-leave-active {
        transition: all 0.3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
        transform: scale(0);
    }
</style>